import type * as Types from '../../../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetAllUniversalGridItemsQueryVariables = Types.Exact<{
  query: Types.ProductCatalogSearchQueryInput;
  first: Types.Scalars['Int'];
  endCursor?: Types.InputMaybe<Types.Scalars['ProductCatalogSearchCursor']>;
  type?: Types.InputMaybe<Types.CatalogTreeRootInput>;
  withFilters: Types.Scalars['Boolean'];
  sourceLimits?: Types.InputMaybe<Array<Types.ProductUniversalSearchSourceLimit> | Types.ProductUniversalSearchSourceLimit>;
  withInventory: Types.Scalars['Boolean'];
}>;

export type GetAllUniversalGridItemsQuery = {
  __typename?: 'Query';
  productCatalogCategoryTreeRoot: { __typename?: 'ProductCatalogCategory'; id: string; heroText?: string | null };
  productUniversalSearchResults: {
    __typename?: 'ProductUniversalSearchResultContainer';
    pagedResults?: {
      __typename?: 'ProductUniversalSearchConnection';
      pageInfo: { __typename?: 'ProductCatalogSearchPageInfo'; hasNextPage: boolean; hasPreviousPage: boolean; startCursor: any; endCursor: any; totalCount: number };
      edges: Array<{
        __typename?: 'ProductUniversalSearchEdge';
        cursor: any;
        node: {
          __typename?: 'ProductUniversalSearchNode';
          source: Types.ProductUniversalItemSource;
          item:
            | {
                __typename: 'ProductExternalOfferContainer';
                offer: {
                  __typename?: 'ProductExternalOffer';
                  id: string;
                  productId: string;
                  productTitle: string;
                  sellerName: string;
                  sellerUrl?: string | null;
                  productThumbnail: { __typename?: 'PhotoSummary'; url: string };
                  productRating?: { __typename?: 'ProductRating'; id: string; averageRating: number; reviewsCount: number } | null;
                  sellerFullPrice: {
                    __typename?: 'MonetaryValue';
                    valueInMinorUnits: number;
                    floatingPointDecimalString: string;
                    currency?: { __typename?: 'Currency'; code: string; places: number } | null;
                  };
                  sellerSalePrice?: {
                    __typename?: 'MonetaryValue';
                    valueInMinorUnits: number;
                    floatingPointDecimalString: string;
                    currency?: { __typename?: 'Currency'; code: string; places: number } | null;
                  } | null;
                };
              }
            | {
                __typename: 'ProductUniversalCatalogItemContainer';
                catalogItem: {
                  __typename?: 'ProductCatalogItem';
                  id: string;
                  title: string;
                  itemType: string;
                  productUrl?: string | null;
                  isFullPrice: boolean;
                  tags: Array<string>;
                  inventory?: { __typename?: 'ProductInventoryResult'; maxQty: number };
                  collectionDisplayInfos: Array<{
                    __typename?: 'ProductCatalogCollectionDisplayInfo';
                    id: string;
                    displayInfoId: string;
                    pdpSectionType?: Types.PDPSectionType | null;
                  }>;
                  tilePresentation: {
                    __typename?: 'ProductCatalogItemTilePresentation';
                    presentationType: Types.ProductCatalogItemTilePresentationType;
                    title: string;
                    shortDescription?: string | null;
                    longDescription?: string | null;
                    isFullPrice: boolean;
                    photos: Array<{ __typename?: 'Photo'; id: string; url: string }>;
                    priceRange?: {
                      __typename?: 'ProductMonetaryValueRange';
                      isSinglePrice: boolean;
                      upperPrice: {
                        __typename?: 'MonetaryValue';
                        floatingPointDecimalString: string;
                        valueInMinorUnits: number;
                        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
                      };
                      lowerPrice: {
                        __typename?: 'MonetaryValue';
                        floatingPointDecimalString: string;
                        valueInMinorUnits: number;
                        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
                      };
                    } | null;
                    fullPriceRange?: {
                      __typename?: 'ProductMonetaryValueRange';
                      isSinglePrice: boolean;
                      upperPrice: {
                        __typename?: 'MonetaryValue';
                        floatingPointDecimalString: string;
                        valueInMinorUnits: number;
                        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
                      };
                      lowerPrice: {
                        __typename?: 'MonetaryValue';
                        floatingPointDecimalString: string;
                        valueInMinorUnits: number;
                        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
                      };
                    } | null;
                  };
                  group?: {
                    __typename?: 'ProductCatalogItemGroup';
                    id: string;
                    tileViewDimension?: {
                      __typename?: 'ProductCatalogItemGroupDimension';
                      id: string;
                      title: string;
                      swatchType: Types.GroupDimensionSwatchType;
                      options: Array<{
                        __typename?: 'ProductCatalogItemGroupDimensionOption';
                        id: string;
                        displayString: string;
                        swatchColor?: { __typename?: 'Color'; hex: string; isLight: boolean } | null;
                      }>;
                    } | null;
                    items: Array<{
                      __typename?: 'ProductCatalogItem';
                      id: string;
                      title: string;
                      itemType: string;
                      productUrl?: string | null;
                      isFullPrice: boolean;
                      tags: Array<string>;
                      groupDimensionOptions: Array<{ __typename?: 'ProductCatalogItemGroupDimensionOption'; id: string }>;
                      brand?: { __typename?: 'ProductCatalogBrand'; id: string; name: string; publicUrlPath: string } | null;
                      photos: Array<{ __typename?: 'Photo'; id: string; url: string }>;
                      price?: {
                        __typename?: 'MonetaryValue';
                        valueInMinorUnits: number;
                        floatingPointDecimalString: string;
                        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
                      } | null;
                      fullPrice?: {
                        __typename?: 'MonetaryValue';
                        valueInMinorUnits: number;
                        floatingPointDecimalString: string;
                        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
                      } | null;
                      storefrontInfo: {
                        __typename?: 'ProductCatalogStorefrontInfo';
                        storefrontStatus: Types.ProductCatalogStorefrontStatus;
                        canAddToCart: boolean;
                        canAddToRegistry: boolean;
                      };
                      rating?: {
                        __typename?: 'RatingProduct';
                        id: string;
                        stats: { __typename?: 'RatingStats'; id: string; averageRating: number; totalReviewCount: number };
                      } | null;
                    }>;
                  } | null;
                  brand?: { __typename?: 'ProductCatalogBrand'; id: string; name: string; publicUrlPath: string } | null;
                  photos: Array<{ __typename?: 'Photo'; id: string; url: string }>;
                  price?: {
                    __typename?: 'MonetaryValue';
                    valueInMinorUnits: number;
                    floatingPointDecimalString: string;
                    currency?: { __typename?: 'Currency'; code: string; places: number } | null;
                  } | null;
                  fullPrice?: {
                    __typename?: 'MonetaryValue';
                    valueInMinorUnits: number;
                    floatingPointDecimalString: string;
                    currency?: { __typename?: 'Currency'; code: string; places: number } | null;
                  } | null;
                  storefrontInfo: {
                    __typename?: 'ProductCatalogStorefrontInfo';
                    storefrontStatus: Types.ProductCatalogStorefrontStatus;
                    canAddToCart: boolean;
                    canAddToRegistry: boolean;
                  };
                  rating?: { __typename?: 'RatingProduct'; id: string; stats: { __typename?: 'RatingStats'; id: string; averageRating: number; totalReviewCount: number } } | null;
                };
              }
            | { __typename: 'ProductUniversalProductContainer' };
        };
      }>;
    } | null;
    allFilters?: Array<{
      __typename?: 'ProductCatalogSearchFilterGroup';
      attributes: Array<{
        __typename?: 'ProductSearchFilterAttribute';
        id: string;
        compositeCode: string;
        isActive: boolean;
        matchingItemsCount?: number | null;
        value: { __typename?: 'ProductAttributeValue'; id: string; title: string; code: string };
      }>;
      attributeGroup: {
        __typename?: 'ProductAttributeGroup';
        id: string;
        title: string;
        code: string;
        valueType: Types.ProductCatalogAttributeValueType;
        filterSelectionType: Types.ProductCatalogAttributeSelectionType;
      };
      selectedPriceRange?: { __typename?: 'ProductCatalogSearchFilterGroupSelectedPrice'; maxValueInMinorUnits?: number | null; minValueInMinorUnits?: number | null } | null;
    }>;
  };
};

export const GetAllUniversalGridItemsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAllUniversalGridItems' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogSearchQueryInput' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endCursor' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogSearchCursor' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CatalogTreeRootInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'withFilters' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sourceLimits' } },
          type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductUniversalSearchSourceLimit' } } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'withInventory' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productCatalogCategoryTreeRoot' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'type' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'type' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'heroText' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productUniversalSearchResults' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'query' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'sourceLimits' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sourceLimits' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pagedResults' },
                  arguments: [
                    { kind: 'Argument', name: { kind: 'Name', value: 'first' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } } },
                    { kind: 'Argument', name: { kind: 'Name', value: 'after' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'endCursor' } } },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageInfo' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProductCatalogSearchPageInfo' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'item' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductUniversalCatalogItemContainer' } },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'catalogItem' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProductCatalogItemSearchSummary' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'inventory' },
                                                      directives: [
                                                        {
                                                          kind: 'Directive',
                                                          name: { kind: 'Name', value: 'include' },
                                                          arguments: [
                                                            {
                                                              kind: 'Argument',
                                                              name: { kind: 'Name', value: 'if' },
                                                              value: { kind: 'Variable', name: { kind: 'Name', value: 'withInventory' } },
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'maxQty' } }] },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductExternalOfferContainer' } },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'offer' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProductExternalOfferSummary' } }],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allFilters' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'withFilters' } } }],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'compositeCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isActive' }, directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }] },
                            { kind: 'Field', name: { kind: 'Name', value: 'matchingItemsCount' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'value' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attributeGroup' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'valueType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'filterSelectionType' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectedPriceRange' },
                        directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'maxValueInMinorUnits' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'minValueInMinorUnits' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProductCatalogSearchPageInfo' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogSearchPageInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProductCatalogItemSearchSummary' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CatalogProductSharedDisplayFields' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'collectionDisplayInfos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayInfoId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pdpSectionType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tilePresentation' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProductCatalogItemTilePresentation' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'group' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CatalogProductTileViewDimensions' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CatalogProductSharedDisplayFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'itemType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brand' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publicUrlPath' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'productUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'price' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currency' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullPrice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currency' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'storefrontInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'storefrontStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canAddToCart' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canAddToRegistry' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rating' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stats' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'averageRating' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalReviewCount' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isFullPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProductCatalogItemTilePresentation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogItemTilePresentation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'presentationType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'longDescription' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'priceRange' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isSinglePrice' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'upperPrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lowerPrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fullPriceRange' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isSinglePrice' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'upperPrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lowerPrice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isFullPrice' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CatalogProductTileViewDimensions' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductCatalogItemGroup' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tileViewDimension' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'swatchType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'options' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayString' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'swatchColor' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Color' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CatalogProductSharedDisplayFields' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'groupDimensionOptions' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Color' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Color' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'hex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLight' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProductExternalOfferSummary' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductExternalOffer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'productId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'productTitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productThumbnail' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productRating' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'averageRating' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reviewsCount' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sellerName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sellerUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sellerFullPrice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currency' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sellerSalePrice' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currency' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAllUniversalGridItemsQuery__
 *
 * To run a query within a React component, call `useGetAllUniversalGridItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUniversalGridItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUniversalGridItemsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      endCursor: // value for 'endCursor'
 *      type: // value for 'type'
 *      withFilters: // value for 'withFilters'
 *      sourceLimits: // value for 'sourceLimits'
 *      withInventory: // value for 'withInventory'
 *   },
 * });
 */
export function useGetAllUniversalGridItemsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllUniversalGridItemsQuery, GetAllUniversalGridItemsQueryVariables>) {
  return ApolloReactHooks.useQuery<GetAllUniversalGridItemsQuery, GetAllUniversalGridItemsQueryVariables>(GetAllUniversalGridItemsDocument, baseOptions);
}
export function useGetAllUniversalGridItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllUniversalGridItemsQuery, GetAllUniversalGridItemsQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetAllUniversalGridItemsQuery, GetAllUniversalGridItemsQueryVariables>(GetAllUniversalGridItemsDocument, baseOptions);
}
export type GetAllUniversalGridItemsQueryHookResult = ReturnType<typeof useGetAllUniversalGridItemsQuery>;
export type GetAllUniversalGridItemsLazyQueryHookResult = ReturnType<typeof useGetAllUniversalGridItemsLazyQuery>;
export type GetAllUniversalGridItemsQueryResult = Apollo.QueryResult<GetAllUniversalGridItemsQuery, GetAllUniversalGridItemsQueryVariables>;
